<template>
  <!-- 푸터 링크 -->
  <div v-if="isVisible" class="wrap_footer_link">
    <div v-for="(menuItem, idx) in menuList.menus" :key="'MW_TEXT_' + idx" class="footer_link_group">
      <button :class="{'active': menuItem.isActive}" class="tit" @click="toggleClass(idx)">{{ menuItem.menuNm }}</button>
      <ul class="nav_menu_list">
        <li v-for="(subMenuItem, subIdx) in menuItem.menus" :key="'MW_TEXT_SUB_' + subIdx">
          <a v-if="subMenuItem.linkUrl" :class="['footer_link', subMenuItem.paramCntnt07]" href="javascript:void(0)" @click="goMenuLink(subMenuItem)">{{ subMenuItem.menuNm }}</a>
          <a v-else :class="['footer_link', subMenuItem.paramCntnt07]" href="javascript:void(0)">{{ subMenuItem.menuNm }}</a>
        </li>
      </ul>
    </div>
  </div>
  <!-- // 푸터 링크 -->
</template>
S
<script>
import { isEmpty } from 'lodash'
import commonMixin from '@/mixin/commonMixin'

export default {
  name: 'TextMenu',
  components: {

  },
  mixins: [commonMixin],
  data () {
    return {
      isVisible: false
      // potltInfo: null,
      // menuList: {}, // 텍스트 메뉴 데이터
      // isActive: false
    }
  },
  computed: {
    potltInfo () {
      const store = window.vue.getStore('courseList')
      if (store && store.state && Array.isArray(store.state.portletList)) {
        return store.state.portletList.find(item => item.potltCd === 'NRW_TXT_MENU')
      }
      return null
    },
    menuList () {
      if (this.potltInfo) {
        const menuTree = this.makeTreeForMenu(this.potltInfo.potltData)
        // menuTree.menus.forEach(menu => {
        //   menu.isActive = false
        // })
        // return menuTree
        // 새로운 배열을 생성하여 각 메뉴에 isActive 속성을 추가
        const updatedMenus = menuTree.menus.map(menu => {
          return { ...menu, isActive: false }
        })
        // 변경된 menus 배열을 포함한 새로운 menuTree 객체를 반환
        return { ...menuTree, menus: updatedMenus }
      }
      return { menus: [] }
    }
  },
  watch: {
    potltInfo (newVal) {
      if (newVal && !isEmpty(newVal.potltData)) {
        this.isVisible = true
      } else {
        this.isVisible = false
      }
    }
  },
  created () {
    // this.fetchPortletList()
  },
  methods: {
    // 웹 모바일 포틀릿 목록 조회
    /*    async fetchPortletList () {
      const params = { sitePotltMenuTyp: 'MWH', langCd: this.getUserLangCd() }

      const fetchDataCallback = (data) => {
        this.potltInfo = data.filter(item => item.potltCd === 'NRW_TXT_MENU')

        if (!Array.isArray(this.potltInfo)) return
        this.potltInfo.forEach(item => {
          if (!isEmpty(item.potltData)) {
            this.isVisible = true
          }

          this.menuList = this.makeTreeForMenu(item.potltData)
        })
      }

      // 데이터 조회
      await this.fetchData('selectHomePortletList', params, fetchDataCallback)
    }, */
    // 클래스 토글
    toggleClass (idx) {
      this.$nextTick(function () {
        const currentBtn = (event.target || event.srcElement)
        if (currentBtn.classList.contains('active')) {
          currentBtn.classList.remove('active')
        } else {
          currentBtn.classList.add('active')
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/nrw/portlet/TextMenu.vue